import styled from 'styled-components';
import tw, { classnames, padding, borderWidth, width, display, flexDirection, divideWidth, divideColor, backgroundColor } from 'tailwindcss-classnames';

export const Container = styled.div.attrs({
    className: classnames(padding('pb-0'))
})``;

export const HeaderContainer = styled.div.attrs({
    className: classnames(backgroundColor('bg-gpas-700'  as any, 'dark:bg-gpas-100'  as any, 'dark:bg-gpas-700' as any), padding('pb-3', 'pt-4', 'px-6'))
})`border: inherit;`

export const MenuItemContainer = styled.div.attrs({
    className: classnames(borderWidth('border-b-2'))
})``;

export const ItemsContent = styled.div.attrs({
    className: classnames(backgroundColor('dark:bg-gray-900' as any), padding('py-0'), width('w-full'), display('flex'), flexDirection('flex-col'), divideWidth('divide-y'), divideColor('divide-gray-200', 'dark:divide-gray-600' as any))
})``;

export const ItemAnchor = styled.a.attrs({
    className: classnames(padding('py-3'))
})`
    border-color: #f7f7f7;
    font-weigth: 400;
`;
